import Vue from 'vue'
import Router from 'vue-router'

const Index = resolve => require(['/page/index'], resolve)
const Authorize = resolve => require(['/page/authorize'], resolve)
const List = resolve => require(['/page/list'], resolve)
const Detail = resolve => require(['/page/detail'], resolve)
const Info = resolve => require(['/page/info'], resolve)
const Error = resolve => require(['/page/error'], resolve)
const Huiyi = resolve => require(['/page/huiyi'], resolve)
const Mid = resolve => require(['/page/mid'], resolve)

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {path: '/index', name: 'index', component: Index},
    {path: '/authorize', name: 'authorize', component: Authorize},
    {path: '/detail', name: 'detail', component: Detail},
    {path: '/info', name: 'info', component: Info},
    {path: '/list', name: 'list', component: List},
    {path: '/error', name: 'error', component: Error},
    {path: '/huiyi', name: 'huiyi', component: Huiyi},
    {path: '/mid', name: 'mid', component: Mid}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js